import { AxiosError } from 'axios';
import api from './api';
import type { ApiError } from './types';

// Description: Login user
// Endpoint: POST /api/auth/login
// Request: { email: string, password: string }
// Response: { email: string, role: string, accessToken: string, refreshToken: string }

// Description: Logout user
// Endpoint: POST /api/auth/logout
// Request: { email: string }
// Response: { message: string }
export const logout = async (email: string) => {
  try {
    const response = await api.post('/auth/logout', { email });
    return response.data;
  } catch (error) {
    console.error('Logout error:', error);
    const axiosError = error as AxiosError<ApiError>;
    throw new Error(axiosError.response?.data?.message || 'Logout failed');
  }
};

// Description: Initiate Google OAuth login
// Endpoint: GET /api/auth/google
// Response: Redirects to Google OAuth page
export const initiateGoogleLogin = async () => {
  try {
        const response = await api.get('/auth/google/url');
        window.location.href = response.data.url;
  } catch (error) {
    console.error('Google login error:', error);
    throw new Error('Failed to initiate Google login');
  }
};

// Description: Initiate Google OAuth login (legacy method)
// Endpoint: GET /api/auth/google
// Response: Redirects to Google OAuth login page
export const loginWithGoogle = async () => {
  try {
        return await initiateGoogleLogin();
  } catch (error) {
    console.error('Google login error:', error);
    throw new Error('Failed to initiate Google login');
  }
};

// Description: Get user role by Google email
// Endpoint: GET /api/auth/role
// Request: { email: string }
// Response: { role: 'admin' | 'expert' | 'main' }
export const getUserRole = async (email: string) => {
  try {
    const response = await api.get(`/api/auth/role?email=${email}`);
    return response.data;
  } catch (error) {
    console.error('Error getting user role:', error);
    const axiosError = error as AxiosError<ApiError>;
    throw new Error(axiosError.response?.data?.message || 'Failed to get user role');
  }
};

// Description: Update user role for Google-authenticated user
// Endpoint: PATCH /api/auth/role
// Request: { email: string, role: 'admin' | 'expert' | 'main' }
// Response: { success: boolean, message: string }
export const updateUserRole = async (email: string, roles: Array<string>) => {
  try {
    const response = await api.patch(`/api/auth/role?email=${email}`, { roles });
    return response.data;
  } catch (error: any) {
    console.error('Update role error:', error);
    console.error('Error response:', error.response);
    throw new Error(error?.response?.data?.message || error.message);
  }
};